module.exports = __webpack_public_path__ + "img/apprehension2.0568291d.jpg";